import HighchartsReact from "highcharts-react-official";
import Highcharts, { height } from "highcharts";
import { useCallback, useEffect, useState } from "react";
import { Card, Col, Row, Tab, Tabs } from "react-bootstrap";

const ContentEngagement = ({ data, label = "top" }) => {
  const path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const [pieOption, setPieOption] = useState({
    chart: {
      type: "pie",
      height: 230,
    },
    title: {
      text: "",
    },
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      horizontalAlign: "center",
      width: "100%",
      layout: "horizontal",
      itemMarginTop: 5,
      itemMarginBottom: 5,
      itemDistance: 10, // gap between each legend item
      symbolPadding: 6, // gap between color dot and text (decrease this)
      symbolWidth: 10,
      symbolHeight: 10,
      symbolRadius: 5,
      itemStyle: {
        color: "#70899E",
        fontSize: "12px",
        fontWeight: "400",
      },
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
  });
  const [lineOption, setLineOption] = useState({
    chart: {
      type: "line",
      plotBorderWidth: 1,
      plotBorderColor: "#E6E6E6",
      height: 228,
    },
    title: {
      text: "",
    },
    yAxis: {
      title: "",
      tickAmount: 5,
      labels: {
        style: {
          color: "#97B6CF",
          fontSize: "10px",
          fontWeight: "400",
        },
        formatter: function () {
          const axis = this.axis;
          const max = axis.max;
          if (this.value === max) {
            return `<span style="white-space:nowrap;">Freq</span>`;
          }
          return this.value;
        },
      },
    },
    xAxis: {
      lineWidth: 1,
      tickInterval: 1,
      lineColor: "#E6E6E6",
      labels: {
        step: 1, // ✅ ensure no skipping
        style: {
          color: "#97B6CF",
          fontSize: "10px",
          fontWeight: "400",
        },
      },
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
          symbol: "circle",
        },
      },
    },
    tooltip: {
      useHTML: true,
      outside: true,
      backgroundColor: "transparent",
      borderWidth: 0,
      shadow: false,
      positioner: function (w, h, point) {
        const chart = this.chart;
        return {
          x: point.plotX + chart.plotLeft - w / 2,
          y: point.plotY + chart.plotTop - h - 10, // ✅ above each point
        };
      },
    },
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemStyle: {
        color: "#70899E",
        fontSize: "12px",
        fontWeight: "400",
      },
    },
    exporting: {
      enabled: false,
    },
  });

  const getToolTipTable = useCallback((dataItem) => {
    return `
    <div style="background:#FAC755; border-radius:12px; padding:10px;">
      <table style="width:100%; border-collapse:collapse;">
        
        <thead>
          <tr style="color:#C29123; border-bottom:1px dashed #fff;">
            <th style="text-align:left;">Total Eng</th>
            <th style="text-align:right;">| ${dataItem?.total}</th>
          </tr>
        </thead>

        <tbody style="color:#fff;">
          <tr>
            <td>Read</td>
            <td style="text-align:right;">| ${dataItem?.view}</td>
          </tr>
          <tr>
            <td>Like</td>
            <td style="text-align:right;">| ${dataItem?.likes}</td>
          </tr>
          <tr>
            <td>Download</td>
            <td style="text-align:right;">| ${dataItem?.download}</td>
          </tr>
          <tr>
            <td>Shared</td>
            <td style="text-align:right;">| ${dataItem?.shared + dataItem?.copy_link}</td>
          </tr>
        </tbody>

      </table>
    </div>
  `;
  }, []);

  const setLineData = (data) => {
    if (data) {
      setLineOption((prev) => ({
        ...prev,
        xAxis: {
          ...prev.xAxis,
          categories: data.map((item) => item.month),
        },
        tooltip: {
          ...prev.tooltip,
          formatter: function () {
            return getToolTipTable(data[this.point.index]);
          },
        },
        series: [
          {
            name: "Content Engagement",
            color: "#FAC755",
            data: data.map((item) => item.total),
          },
        ],
      }));
    }
  };

  const setPieData = (data) => {
    if (data) {
      const series = [
        {
          name: "Engagement",
          data: data?.map((item) => ({
            name: item.action === "View" ? "Read" : item.action,
            y: item.count,
          })),
        },
      ];
      setPieOption((prev) => ({
        ...prev,
        series,
      }));
    }
  };

  useEffect(() => {
    if (data) {
      setLineData(data?.line);
      setPieData(data?.pie?.data);
    }
  }, [data]);

  const getCardData = useCallback((item) => {
    const cat = {
      All: "narrative_all.svg",
      "E-Learning": "narrative_e_learning.svg",
      Videos: "narrative_video.svg",
      Publications: "narrative_publication.svg",
      Posters: "narrative_posters.svg",
      Flyer: "narrative_flyer.svg",
      Form: "narrative_form.svg",
      "Slide Deck": "narrative_slide_deck.svg",
      Collection: "narrative_collection.svg",
      Websites: "narrative_website.svg",
      FAQ: "narrative_faq.svg",
    };
    const category = item?.category;
    return (
      <Card className="custom-card">
        <Card.Body>
          <div className="card-content">
            <div className="icon-box">
              <img
                src={
                  path_image +
                  (cat[category] ? cat[category] : "narrative_e_learning.svg")
                }
                alt={category}
              />
            </div>
            <div className="text-content">
              <p>{item?.title}</p>
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  }, []);

  return (
    <div className="profile-engagement vwd-content-engagement">
      <div className="profile-engagement-block">
        <Row>
          <Col
            className="hcp-profile-view line-graph"
            id="box-2"
            data-printable="true"
            colSpan={12}
          >
            <div className="profile-title d-flex align-items-center justify-content-between">
              <p style={{ color: "#004A89" }}>Content engagement</p>
            </div>
            <div className="hcp-profile-content live-events-graph">
              <p>Engagement in last 12 months</p>

              <div className="profile-view-graph">
                <HighchartsReact highcharts={Highcharts} options={lineOption} />
              </div>
            </div>
          </Col>
          <Col
            className="hcp-profile-view pie-graph"
            id="box-1"
            data-printable="true"
          >
            <div className="hcp-profile-content p-0">
              <div className="profile-view-graph">
                {" "}
                <div className="live-stream-tabs-data">
                  <Tabs defaultActiveKey="all">
                    <Tab eventKey="all" title="All">
                      <div className="hcp-profile-content live-events-graph">
                        <p>Last 12 months engagement</p>
                        {data?.pie?.total > 0 ? (
                          <div className="profile-view-graph">
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={pieOption}
                            />
                          </div>
                        ) : (
                          <div className="no-data">No data available</div>
                        )}
                      </div>
                    </Tab>
                    <Tab eventKey="read" title="Read">
                      <div className="hcp-profile-content live-events-graph">
                        <p>3 {label} read content</p>
                        <div className="card-content-box">
                          {data?.pie?.total ? (
                            data &&
                            Array.isArray(data?.pie?.data) &&
                            data?.pie?.data
                              ?.filter((item) => item?.action === "View")[0]
                              ?.topPdfs?.map((item) => {
                                return getCardData(item);
                              })
                          ) : (
                            <div className="no-data">No data available</div>
                          )}
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="downloaded" title="Downloaded">
                      <div className="hcp-profile-content live-events-graph">
                        <p>3 {label} downloaded content</p>
                        <div className="card-content-box">
                          {data?.pie?.total ? (
                            data &&
                            Array.isArray(data?.pie?.data) &&
                            data?.pie?.data
                              ?.filter(
                                (item) => item?.action === "Downloaded",
                              )[0]
                              ?.topPdfs?.map((item) => {
                                return getCardData(item);
                              })
                          ) : (
                            <div className="no-data">No data available</div>
                          )}
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="liked" title="Liked">
                      <div className="hcp-profile-content live-events-graph">
                        <p>3 {label} liked content</p>
                        <div className="card-content-box">
                          {data?.pie?.total ? (
                            data &&
                            Array.isArray(data?.pie?.data) &&
                            data?.pie?.data
                              ?.filter((item) => item?.action === "Liked")[0]
                              ?.topPdfs?.map((item) => {
                                return getCardData(item);
                              })
                          ) : (
                            <div className="no-data">No data available</div>
                          )}
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="shared" title="Shared">
                      <div className="hcp-profile-content live-events-graph">
                        <p>3 {label} shared content</p>
                        <div className="card-content-box">
                          {data?.pie?.total ? (
                            data &&
                            Array.isArray(data?.pie?.data) &&
                            data?.pie?.data
                              ?.filter((item) => item?.action === "Shared")[0]
                              ?.topPdfs?.map((item) => {
                                return getCardData(item);
                              })
                          ) : (
                            <div className="no-data">No data available</div>
                          )}
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ContentEngagement;
